import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { DashboardUnits, LegendData } from '@dataTypes/dashboard.types'
import { formatNumber, formatValueByUnit } from '@utils/index'

type CollectionsData = {
  goal: number | string
  actual: number | string
  unit: DashboardUnits
  gross: number | string
  net: number | string
}
type DisplayCard = {
  displayTwoText: boolean
  data: CollectionsData
  legendData?: LegendData[]
}

function CardContainer({
  displayTwoText,
  data,
  legendData,
}: DisplayCard): React.ReactElement {
  return (
    <Row className="mt-5 p-3 text-center text-black">
      {displayTwoText ? (
        <>
          <Col md={6} className="text-center">
            <div className="display-5">
              {formatValueByUnit(data.gross, data.unit) || ''}
            </div>
            <div className="fw-bolder">{`Gross`}</div>
          </Col>
          <Col md={6} className="text-center">
            <div className="display-5">
              {formatValueByUnit(data.net, data.unit) || ''}
            </div>
            <div className="fw-bolder">{`Net`}</div>
          </Col>
        </>
      ) : (
        <Col md={12} className="text-center">
          <div className="display-3">
            {formatValueByUnit(data.actual, data.unit) || ''}
          </div>
          <div className="fw-bolder">{`Target`}</div>
          <div className="fw-bolder">{`${formatValueByUnit(data.goal, data.unit) || ''} 
          ${data.unit === '$' ? '' : ' or less'}`}</div>
        </Col>
      )}

      {legendData &&
        legendData.map(({ name, value, showCurrency }) => (
          <Col className={`col-md-4 mt-5`} key={`${name}`}>
            <div className="text-black">{name}</div>
            <div className="text-black fw-bolder">
              {formatNumber(value, showCurrency)}
            </div>
          </Col>
        ))}
    </Row>
  )
}

export default CardContainer
